'use client';

import React, { ReactElement, Children, isValidElement, cloneElement } from 'react';
import { AccordionItemProps } from './AccordionItem';
import styles from './Accordion.module.scss';

export interface AccordionProps {
  children: ReactElement<AccordionItemProps>[];
  openIndex?: number | null; // 외부에서 제어할 수 있도록 변경
  defaultOpenIndex?: number | null;
  headerArrow?: 'start' | 'end';
  className?: string;
}

const Accordion: React.FC<AccordionProps> = ({
  children,
  className,
  openIndex = null, // 외부에서 제어
  defaultOpenIndex = null,
  headerArrow = 'end',
}) => {
  const [internalOpenIndex, setInternalOpenIndex] = React.useState<number | null>(defaultOpenIndex);
  const isControlled = openIndex !== null;
  const containerClass = className ? `${styles.container} ${className}` : styles.container;

  const handleToggleItem = (index: number) => {
    if (!isControlled) {
      setInternalOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    }
  };

  const currentOpenIndex = isControlled ? openIndex : internalOpenIndex;

  return (
    <div className={containerClass}>
      {Children.map(children, (child, index) => {
        if (isValidElement<AccordionItemProps>(child)) {
          return cloneElement(child, {
            isOpen: currentOpenIndex === index,
            arrow: headerArrow,
            onClick: () => {
              handleToggleItem(index);
              if (child.props.onClick) {
                child.props.onClick();
              }
            },
          });
        }
        return null;
      })}
    </div>
  );
};

export default Accordion;
